<ng-container *transloco="let t">
  <p-dialog
    [modal]="true"
    [dismissableMask]="false"
    [draggable]="false"
    [(visible)]="display"
    [styleClass]="dialogStyleClass"
    [formGroup]="form"
    (onHide)="closePopupList()"
  >
    <p-header><i class="mr-1" [class]="popupWindowIcon"></i> {{ popupWindowTitle }}</p-header>

    <p-listbox
      #listbox
      formControlName="value"
      optionDisabled="disabled"
      optionValue="column1"
      optionLabel="column2"
      [filter]="popupFilter"
      filterPlaceHolder="{{ t('core.components.modal_listbox.filter_placeholder') }}"
      styleClass="z-combo-box z-listbox z-listbox-small"
      [style]="style"
      [options]="list"
      (onDblClick)="select()"
    >
      <ng-template let-data pTemplate="item">
        <span [class]="columnWidthClass1" *ngIf="displayColumn1">
          {{ data.column1 }}
        </span>

        <span [class]="columnWidthClass2" *ngIf="displayColumn2">
          {{ data.column2 }}
        </span>

        <span [class]="columnWidthClass3" *ngIf="displayColumn3">
          {{ data.column3 }}
        </span>

        <span [class]="columnWidthClass4" *ngIf="displayColumn4">
          {{ data.column4 }}
        </span>

        <span [class]="columnWidthClass5" *ngIf="displayColumn5">
          {{ data.column5 }}
        </span>
      </ng-template>
    </p-listbox>

    <p-footer>
      <p-button [icon]="selectButtonIcon" (click)="select()" [label]="selectButtonLabel" [styleClass]="selectButtonClass"></p-button>

      <p-button
        (click)="closePopupList()"
        [icon]="cancelButtonIcon"
        [label]="cancelButtonLabel"
        [styleClass]="cancelButtonClass"
      ></p-button>
    </p-footer>
  </p-dialog>
</ng-container>
